import { Link } from "react-router-dom";
import "./SponsorAndPartnerLogos.css"
import pearson_logo from "../../../images/universal/SponsorAndPartnerLogos/Pearson_Logo_Purple.svg";
import pearson_logo_white from "../../../images/universal/SponsorAndPartnerLogos/Pearson_Logo_White.svg";
import cnd_logo from "../../../images/universal/SponsorAndPartnerLogos/CnD_Logo_Dark.svg";
import cnd_logo_white from "../../../images/universal/SponsorAndPartnerLogos/CnD_Logo_White.svg";
import uon_logo_dark from "../../../images/universal/SponsorAndPartnerLogos/UoN_Logo_Dark.svg";
import uon_logo_white from "../../../images/universal/SponsorAndPartnerLogos/UoN_Logo_White.svg";

function SponsorAndPartnerLogos({ align = "left", colourway = "dark" }) {
    const alignment = (align === "center") ? "align-center" : "align-left";

    // choose logos based on colourway ("dark" by default). "light" uses white logos.
    const pearsonLogoSrc = (colourway === "light") ? pearson_logo_white : pearson_logo;
    const cndLogoSrc = (colourway === "light") ? cnd_logo_white : cnd_logo;
    const uonLogoSrc = (colourway === "light") ? uon_logo_white : uon_logo_dark;

    return(
        <div className={`sponsors-and-partners ${alignment}`}>
            <div className="sponsor-section">
                <p className="mini-section-heading">Sponsored by</p>
                <a href="https://qualifications.pearson.com/en/qualifications/edexcel-gcses/computer-science-2020/switch-to-pearson.html?utm_source=missionencodeable&utm_medium=website-affiliate&utm_campaign=GBEhttps://qualifications.pearson.com/en/qualifications/edexcel-gcses/computer-science-2020/switch-to-pearson.html?utm_source=missionencodeable&utm_medium=website-affiliate&utm_campaign=GBSECS0123GCSEAQ" target="_blank" rel="noopener noreferrer">
                    <img src={pearsonLogoSrc} className="first-sponsor-logo" alt="Pearson" />
                </a>
                <a href="https://www.nottingham.ac.uk/computerscience/" target="_blank" rel="noopener noreferrer">
                    <img src={uonLogoSrc} alt="University of Nottingham" />
                </a>
            </div>
            <div className={`divider divider-${colourway}`}></div>
            <div className="partnership-section">
                <p className="mini-section-heading">In partnership with</p>
                <Link to="/craig-n-dave-partnership">
                    <img src={cndLogoSrc} alt="Craig 'n' Dave" />
                </Link>
            </div>
        </div>
    )
}

export default SponsorAndPartnerLogos;